module.exports = __webpack_public_path__ + "img/g_select.2905dc9f.png";